module.exports = __webpack_public_path__ + "assets/img/gpc.6345ef76.png";